import React, { useState } from 'react';
import styles from './AppointmentTable.module.css';
import AppointmentCell from './AppointmentCell/AppointmentCell';
import { Icons, TerminalsIcon } from '@/assets';
import { ReactSVG } from 'react-svg';
import formatDateToWeeks from '@/ctUtlis/formatDateToWeeks';
import { useTimeAgoWithUpdates } from '@/ctUtlis/timeAgoWithUpdates';
import { Icon } from '@/components/Icon';
import { LinksPopper } from '@/screens/Appointments/componenets/LinksPopper';

// Component to display time with updates for each terminal
const TerminalTimeDisplay = ({ updatedAt }) => {
  const timeDisplay = useTimeAgoWithUpdates(updatedAt);
  if (!updatedAt) {
    return <span>Update Not Available</span>;
  }
  return (
    <span>
      {timeDisplay.includes('Invalid date')
        ? 'Update Not Available'
        : 'Update: ' + timeDisplay}
    </span>
  );
};

const AppointmentTable = ({
  data,
  subTitle,
  cabinId,
  containerId,
  setAppointmentSet,
  appointmentSet,
  shift,
  containerName,
  ContainerOptions,
  Container,
  SSL,
  Size,
  selectedStatus,
  setSelected,
  parentRef,
  isAutobookPage,
  loading,
  /** Avail Check History: optional (rowTerminalId) => snapshot rows or undefined */
  availHistoryGetSnapshotAvailabilities,
  /** If true + snapshot rows exist, open read-only snapshot modal instead of booking popover */
  availHistoryUseSnapshotModal,
  availHistoryOnOpenSnapshotModal,
  /** صفحهٔ Avail History: بدون Book/Reschedule؛ فقط Close در پاپ‌آور */
  availHistoryDisableBooking,
  /** اسنپ‌شات تاریخچه (غیر now): فقط ردیف این terminalId قابل کلیک؛ null = بدون محدودیت */
  availHistoryRestrictClicksToTerminalId,
}) => {
  const [selectedRowForLinks, setSelectedRowForLinks] = useState(null);
  const [popperForLinksPosition, setPopperForLinksPosition] = useState({
    top: 0,
    right: 0,
    height: 0,
    center: 0,
  });
  const [page, setPage] = useState(0);
  const PAGE_SIZE = 6;
  const [selectedData, setSelectedData] = useState();
  const processedData = data;
  const processSchedules = (gate_schedules) => {
    let scheduleArray = Object.entries(gate_schedules || {})
      .sort(([dateA], [dateB]) => new Date(dateA) - new Date(dateB)) // Ensure sorted order
      .map(([date, shifts]) => ({ date, shifts }));
    while (scheduleArray.length < PAGE_SIZE) {
      scheduleArray.push({ date: `Empty-${scheduleArray.length}`, shifts: {} });
    }
    return scheduleArray;
  };

  const actualDataLength = Math.max(
    ...processedData?.map((row) => Object.keys(row.gate_schedules || {}).length)
  );
  const totalPages = Math.ceil(actualDataLength / PAGE_SIZE);

  const scheduleDates = formatDateToWeeks(processedData[0]?.gate_schedules);

  const paginatedScheduleDates =
    scheduleDates && scheduleDates.length > PAGE_SIZE
      ? (() => {
          const startIndex = page * PAGE_SIZE;
          const endIndex = (page + 1) * PAGE_SIZE;

          // If the last page would have fewer than PAGE_SIZE dates,
          // shift the range to always show PAGE_SIZE dates
          if (endIndex > scheduleDates.length) {
            const adjustedStartIndex = Math.max(
              0,
              scheduleDates.length - PAGE_SIZE
            );
            return scheduleDates.slice(
              adjustedStartIndex,
              scheduleDates.length
            );
          }

          return scheduleDates.slice(startIndex, endIndex);
        })()
      : scheduleDates;

  return (
    <div style={{ height: '100%' }}>
      <div className={styles.subTitleContainer}>
        <div className={styles.buttonContainer}>
          <div
            className={`${styles.button} ${page === 0 ? styles.disabled : ''}`}
            onClick={() => page > 0 && setPage(page - 1)}>
            <ReactSVG
              src={Icons.leftArrow}
              className={styles.buttonArrow}
              beforeInjection={(svg) => {
                svg.querySelectorAll('path').forEach((path) => {
                  path.setAttribute(
                    'stroke',
                    page === 0 ? '#CACFD8' : '#131517'
                  );
                });
              }}
            />
            <span style={{ color: page === 0 ? '#CACFD8' : '#131517' }}>
              Prev
            </span>
          </div>
          <div
            className={`${styles.button} ${
              page >= totalPages - 1 ? styles.disabled : ''
            }`}
            onClick={() => page < totalPages - 1 && setPage(page + 1)}>
            <span
              style={{
                color: page >= totalPages - 1 ? '#CACFD8' : '#131517',
              }}>
              Next
            </span>
            <ReactSVG
              src={Icons.rightArrow}
              className={styles.buttonArrow}
              beforeInjection={(svg) => {
                svg.querySelectorAll('path').forEach((path) => {
                  path.setAttribute(
                    'stroke',
                    page >= totalPages - 1 ? '#CACFD8' : '#131517'
                  );
                });
              }}
            />
          </div>
        </div>
        {subTitle && (
          <span
            style={{
              fontSize: isAutobookPage ? '14px' : '16px',
              marginTop: isAutobookPage ? '-12px' : '0px',
            }}
            className={styles.subTitle}>
            {subTitle}
          </span>
        )}
      </div>
      <div
        style={{
          display: isAutobookPage ? 'unset' : '',
        }}>
        <div
          id="autobookTable"
          className={
            processedData?.length === 0
              ? styles.tableScrollContainerSpace
              : isAutobookPage
              ? styles.tableScrollContainer
              : styles.tableScrollContainerSpace
          }>
          <table
            style={{
              width:
                processedData?.length === 0
                  ? '100%'
                  : isAutobookPage
                  ? '100%'
                  : '',
              minWidth:
                processedData?.length === 0
                  ? 'auto'
                  : isAutobookPage
                  ? '1340px'
                  : '',
            }}
            className={styles.container}>
            <thead>
              <tr className={styles.header}>
                <th className={styles.terminalHeader}>Terminal</th>
                {paginatedScheduleDates?.map((day, index) => (
                  <th key={index} className={styles.dayHeader}>
                    <div
                      className={
                        page === 0 && index === 0
                          ? styles.firstDay
                          : styles.dayContainer
                      }>
                      {day}
                    </div>
                    <div className={styles.shiftHeader}>
                      <div
                        className={
                          page === 0 && index === 0 && shift
                            ? styles.activeShift
                            : styles.shift
                        }>
                        {page === 0 && index === 0 && shift && (
                          <div className={styles.dot} />
                        )}
                        1st
                      </div>
                      <div className={styles.border} />
                      <div
                        className={
                          page === 0 && index === 0 && !shift
                            ? styles.activeShift
                            : styles.shift
                        }>
                        {page === 0 && index === 0 && !shift && (
                          <div className={styles.dot} />
                        )}
                        2nd
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className={styles.body}>
              {processedData?.length === 0 && !loading ? (
                <tr className="flex items-start gap-3 my-10 justify-center px-4">
                  <Icon src={Icons.infoEmptyList} width="20" height="20" />
                  <p className="text-icon-gray text-sm text-center m-0">
                    No data available at the moment. Data will be displayed here
                    once available.
                  </p>
                </tr>
              ) : (
                processedData?.map((row, rowIndex) => {
                  const historyRowLocked =
                    availHistoryRestrictClicksToTerminalId != null &&
                    Number(row.id) !==
                      Number(availHistoryRestrictClicksToTerminalId);
                  const schedules = processSchedules(row.gate_schedules);
                  const paginatedSchedules =
                    schedules && schedules.length > PAGE_SIZE
                      ? (() => {
                          const startIndex = page * PAGE_SIZE;
                          const endIndex = (page + 1) * PAGE_SIZE;

                          // If the last page would have fewer than PAGE_SIZE dates,
                          // shift the range to always show PAGE_SIZE dates
                          if (endIndex > schedules.length) {
                            const adjustedStartIndex = Math.max(
                              0,
                              schedules.length - PAGE_SIZE
                            );
                            return schedules.slice(
                              adjustedStartIndex,
                              schedules.length
                            );
                          }

                          return schedules.slice(startIndex, endIndex);
                        })()
                      : schedules;

                  return (
                    <tr key={rowIndex} className={styles.row}>
                      <td className="relative 3xl:w-1/2 3xl:box-border">
                        <div
                          className={`${styles.terminalCard} cursor-pointer relative`}
                          onClick={(e) => {
                            e.preventDefault();
                            const rect =
                              e.currentTarget.getBoundingClientRect();
                            setSelectedRowForLinks(row);
                            setPopperForLinksPosition({
                              top: rect.top,
                              right: rect.right,
                              height: rect.height,
                              center: rect.height + rect.height / 2,
                              width: rect.width,
                            });
                          }}>
                          <img
                            width={100}
                            src={TerminalsIcon[row.slug?.replace(/\s+/g, '')]}
                            alt={row.slug}
                          />

                          {row.slug}
                          <TerminalTimeDisplay updatedAt={row?.updated_at} />
                        </div>
                        {selectedRowForLinks?.slug === row.slug && (
                          <LinksPopper
                            selectedRowForLinks={selectedRowForLinks}
                            popperForLinksPosition={popperForLinksPosition}
                            setSelectedRowForLinks={setSelectedRowForLinks}
                          />
                        )}
                      </td>
                      {row.blur_status === 1 && (
                        <td
                          colSpan={paginatedSchedules.length}
                          className={` absolute  ${styles.blurContainer}`}>
                          <div className="font-averta relative flex h-full flex-col gap-2 items-center justify-center bg-white box-border z-99 border border-solid border-border-tertiary rounded">
                            <div className="flex items-center font-bold gap-1 text-xs text-gray-1000 ">
                              <Icon
                                src={Icons.infoGray}
                                width="16"
                                height="16"
                                color="#2B303B"
                              />
                              Temporary data issue
                            </div>
                            <div className="text-xs text-primary-text">
                              We're working on reconnecting to this terminal.
                              Data will refresh automatically once fixed
                            </div>
                          </div>
                        </td>
                      )}
                      {row.refreshing_slots && (
                        <td
                          colSpan={paginatedSchedules.length}
                          className={` absolute  ${styles.blurContainer} ${styles.blurContainerNotAvailable}`}>
                          <div className="relative flex h-full flex-col gap-2 items-center justify-center  bg-white bg-opacity-30 backdrop-blur-6 box-border z-10 border border-solid border-border-tertiary rounded">
                            <div className="font-averta flex items-center font-bold gap-1 text-xs text-gray-1000 ">
                              <svg
                                className={styles.animateSpinReverse}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 25 24"
                                fill="none">
                                <path
                                  d="M21.5 12C21.5 9.61305 20.5518 7.32387 18.864 5.63604C17.1761 3.94821 14.8869 3 12.5 3C9.98395 3.00947 7.56897 3.99122 5.76 5.74L3.5 8"
                                  stroke="black"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M3.5 3V8H8.5"
                                  stroke="black"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M3.5 12C3.5 14.3869 4.44821 16.6761 6.13604 18.364C7.82387 20.0518 10.1131 21 12.5 21C15.016 20.9905 17.431 20.0088 19.24 18.26L21.5 16"
                                  stroke="black"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M16.5 16H21.5V21"
                                  stroke="black"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              Updating time slots for this terminal, please hold
                              on…
                            </div>
                          </div>
                        </td>
                      )}
                      {paginatedSchedules.map((cell, cellIndex) => (
                        <td key={cellIndex} className={styles.cell}>
                          {cellIndex !== 0 && (
                            <div className={styles.borderCell} />
                          )}
                          {['shift1', 'shift2'].map((shiftKey, index) => {
                            const shiftCell = cell.shifts?.[shiftKey];
                            const interactiveCursor =
                              shiftCell?.available_count > 0 ||
                              (shiftCell?.single === 0 &&
                                shiftCell?.available_count === 0 &&
                                shiftCell?.status !== 0)
                                ? 'pointer'
                                : 'default';
                            return (
                            <>
                              <div
                                key={index}
                                className={styles.card}
                                style={{
                                  backgroundColor:
                                    shiftCell?.bg_highlight === 'GREEN' ||
                                    shiftCell?.bg_highlight === 'RED-GREEN'
                                      ? '#EAF7F0'
                                      : 'transparent',
                                  cursor: historyRowLocked
                                    ? 'default'
                                    : interactiveCursor,
                                  pointerEvents: historyRowLocked
                                    ? 'none'
                                    : undefined,
                                  opacity: historyRowLocked ? 0.55 : undefined,
                                }}>
                                <AppointmentCell
                                  parentRef={parentRef}
                                  data={cell.shifts?.[shiftKey] || undefined}
                                  availHistoryGetSnapshotAvailabilities={
                                    availHistoryGetSnapshotAvailabilities
                                  }
                                  availHistoryUseSnapshotModal={
                                    availHistoryUseSnapshotModal
                                  }
                                  availHistoryOnOpenSnapshotModal={
                                    availHistoryOnOpenSnapshotModal
                                  }
                                  availHistoryDisableBooking={
                                    availHistoryDisableBooking
                                  }
                                  appset={
                                    appointmentSet
                                      ? appointmentSet[row?.id]?.status !==
                                          'CANCELED' &&
                                        appointmentSet[row?.id]?.status !==
                                          'REJECTED' &&
                                        appointmentSet[row?.id]?.status !==
                                          'PENDING_RESERVE' &&
                                        appointmentSet[row?.id]?.status !==
                                          'RESERVATION_FAILED' &&
                                        appointmentSet[row?.id]?.status !==
                                          'EXPIRED' &&
                                        appointmentSet[row?.id]?.dateTocheck ===
                                          cell?.date &&
                                        appointmentSet[row?.id]?.shift ===
                                          index + 1 &&
                                        Number(
                                          appointmentSet[row?.id]?.terminalId
                                        ) === row.id &&
                                        appointmentSet[row?.id]?.time &&
                                        true
                                      : false
                                  }
                                  row={row}
                                  cell={cell}
                                  index={index}
                                  cabinId={cabinId}
                                  containerId={containerId}
                                  setAppointmentSet={setAppointmentSet}
                                  appointmentSet={
                                    appointmentSet ? appointmentSet[row.id] : []
                                  }
                                  containerName={containerName}
                                  setSelectedData={setSelectedData}
                                  selectedData={selectedData}
                                  ContainerOptions={ContainerOptions}
                                  Container={Container}
                                  SSL={SSL}
                                  Size={Size}
                                  selectedStatus={selectedStatus}
                                  setSelected={setSelected}
                                  isAutobookPage={isAutobookPage}
                                />
                              </div>
                            </>
                            );
                          })}
                        </td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AppointmentTable;
